<template lang="pug">
.filters-info
	.filters-total(:style="styles.primary.color") Results: {{ read("totalResults") }}
	.filters-reset(
		v-if="data && data.length > 3",
		:style="styles.primary.color", 
		@keypress.enter="$emit('reset')", 
		@click="$emit('reset')", 
		tabindex="0",
		data-text="Reset Filters") Reset Filters
</template>

<script>
import Theme from '@/listing-app/mixins/Theme'
export default {
	name: "Meta",
	mixins: [Theme],
  props: ["data"]
}
</script>


<style lang="scss" scoped>
.filters-info {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.filters-total,
.filters-reset {
  font-size: 20px;
  line-height: 1;
  padding: 10px 10px;
}

.filters-total {
  @include justify;
	font-family: $fontFamilyHeadings;
}

.filters-reset {
  cursor: pointer;
  border: 2px solid transparent;
  box-sizing: border-box;
  line-height: 1;
  &:hover {
    background: currentColor !important;
    font-size: 0;
    &:before {
      content: attr(data-text);
      color: $white;
      font-size: 20px;
      line-height: 1;
    }
  }
}
</style>
